export const getUrl = (path, ext) => {
  var buff = [];
  if (path.indexOf('http') !== 0 && path.charAt(0) !== '/') {
    buff.push('/');
  }
  buff.push(path);
  if (typeof ext != 'undefined') {
    if (ext.charAt(0) != '.') {
      ext = '.' + ext;
    }
    buff.push(ext);
  }
  return buff.join('');
};

export const apiPath = (path) => {
  return '/api' + getUrl(path);
};

export const jsonPath = (path) => {
  return getUrl(path, '.json');
};

export const buildUrl = (path, params) => {
  var q = [];
  for (var key in params) {
    var val = encodeURIComponent(params[key]);
    q.push(`${key}=${val}`);
  }
  return path + '?' + q.join('&');
};

export const getParameter = (key) => {
  var l = location;
  if (!l) {
    return null;
  }
  var s = l.search;
  if (!s) {
    return null;
  }
  var reg = new RegExp(`[?&]${key}(=([^&#]*)|&|#|$)`);
  var results = reg.exec(s);
  if (!results) {
    return null;
  }
  if (!results[2]) {
    return '';
  }
  let param = results[2];
  try {
    return decodeURIComponent(param);
  } catch {
    return param;
  }
};
